import React           from 'react';
//import styled          from '@emotion/styled';
import { withRouter }  from 'react-router';
import { connect }     from 'react-redux';
import { isLoggedIn }  from '../../../../utils/authService';

class FeedbackWidget extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      value  : this.props.value,
      render : this.props.render
    };
  }
  
  componentDidMount() {
    this.fixFeedback();
  }
  
  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
        render: this.props.render
      },
      function() {
        this.fixFeedback();
      });
    }
  }
  
  fixFeedback() {
    var rsc = document.getElementsByClassName('rsc');
    if (this.state.render && (isLoggedIn() || this.state.value)) {
      // Add Feedback icon HTML to DOM manually
      
      var btn = document.getElementsByClassName('rsc-float-button');
      if (btn && btn[0]) {
        if (document.querySelectorAll('.rsc-float-button .feedback-link__icon').length === 0) {
	        var svg = document.getElementsByTagName("svg");
          svg[0].setAttribute('aria-label', 'Feedback button');
          var div = document.createElement('div');
        
          var icon = document.createElement('span');
          icon.setAttribute('class', 'feedback-link__icon');
          icon.setAttribute('aria-label', 'Feedback icon');
          
          var message = document.createElement('span');
          message.setAttribute('class', 'feedback-link__message');
          message.innerHTML = 'Feedback';
          message.setAttribute('aria-label', 'Feedback label');
          
          div.innerHTML = icon.outerHTML + message.outerHTML;
          btn[0].appendChild(div); 
          btn[0].style['background'] = 'white';
          btn[0].setAttribute('aria-label', 'Feedback button');
          btn[0].setAttribute('tabindex', '0');
        }
      }
      
      if (rsc && rsc[0]) {
        rsc[0].style['display'] = 'block';
        rsc[0].setAttribute('aria-label', 'Feedback button block');
      }
    }
    else {
      if (rsc && rsc[0]) {
        rsc[0].style['display'] = 'none';
        rsc[0].setAttribute('aria-label', 'Feedback button block');
      }
    }
    var rscheader = document.getElementsByClassName("rsc-header-close-button");
    if (rscheader) {
      rscheader[0].setAttribute("aria-label", 'Feedback close button');
      rscheader[0].setAttribute('tabindex', '0');
      var closesvg = rscheader[0].getElementsByTagName("svg");
      if (closesvg && closesvg[0]) {
        closesvg[0].setAttribute("aria-label", 'Feedback close button image');
      }
      var closepaths = closesvg[0].getElementsByTagName("path");
      if (closepaths && closepaths[0] && closepaths[1]) {
	      closepaths[0].setAttribute("aria-label", 'Feedback close button image');
	      closepaths[1].setAttribute("aria-label", 'Feedback close button image');
      }
    }
    var rscinput = document.getElementsByClassName("rsc-input");
    if (rscinput && rscinput[0]) {
      rscinput[0].setAttribute('role', 'feedback');
      rscinput[0].setAttribute('aria-label', 'Feedback text input area');
    }
    var rscfooter = document.getElementsByClassName("rsc-footer");
    if (rscfooter && rscfooter[0]) {
      rscfooter[0].setAttribute('role', 'feedback');
      rscfooter[0].setAttribute('aria-label', 'Feedback text footer');
    }
    var rscbutton = document.getElementsByClassName("rsc-submit-button");
    if (rscbutton && rscbutton[0]) {
      rscbutton[0].setAttribute('role', 'feedback');
      rscbutton[0].setAttribute('aria-label', 'Feedback submit button');

      var btnsvg = rscbutton[0].getElementsByTagName("svg");
      if (btnsvg && closesvg[0]) {
        btnsvg[0].setAttribute("aria-label", 'Feedback submit button image');
      }
      var poly = btnsvg[0].getElementsByTagName("polygon");
      if (poly && poly[0]) {
	      poly[0].setAttribute("aria-label", 'Feedback close button image polygon');
      }
    }
  }
 
  render() {
    return (
      <div>
        { this.state.render ?
          <style dangerouslySetInnerHTML={{__html: `    
            /* Feedback */

            @media (min-width: 960px) {
              .rsc .rsc-float-button {
                bottom: calc(15% - 89px);
                width: 75px !important;
                height: 79px !important;
              }
            }

            @media (max-width: 960px) {
              .rsc .rsc-float-button:before {
                font-size: 20px !important;
              }
            }

            .rsc .rsc-float-button {
              position: fixed;
              bottom: calc(15% - 52px);
              right: 20px;
              bottom: 50px;
              width: 42px;
              height: 42px;
              border: 3px solid #d64309;
              background: #fff;
              z-index: 99;
              fill: inherit;
              box-shadow: none;
              border-radius: inherit;
              display: inherit;
            }
	    .rsc-float-button:focus{
              outline: 9px solid #d64309;
	    }
	    .rsc-submit-button:focus{
              outline: 9px solid #d64309;
	    }
	    .search-bar:focus{
              outline: 3px solid #d64309;
	    }

            .rsc .rsc-float-button svg {
              display: none;
            }
          `}} />
          :
          <span></span>
        }
        <span style={{ display: 'none' }}>
          {this.state.value}
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeedbackWidget));
